
import './ContactUs.css';
let ContactUs= ()=>{

    return(
        <div className='contactus_main_div'>
            <h1 className='contactusheading'>Contact Us</h1>
            <iframe className='mapiframe' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14377.883326100951!2d83.61632518816913!3d25.721938919625615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39921d2fab36853f%3A0x7bc2bf915219d664!2sTilari%2C%20Uttar%20Pradesh%20233303!5e0!3m2!1sen!2sin!4v1714623896424!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    
            
        </div>
    );
}
export default ContactUs; 